import { StepCard } from '@/components/StepCard';
import { trackContactClick } from '@/lib/analytics';

const steps = [
  {
    number: 1,
    title: 'Consultoria Inicial',
    description: 'Analisamos sua situação patrimonial, objetivos e necessidades. Entendemos seu contexto familiar e identificamos as melhores estratégias para seu caso.',
  },
  {
    number: 2,
    title: 'Estudo de Viabilidade',
    description: 'Elaboramos um estudo personalizado com projeção de economia tributária, estrutura societária ideal e cronograma de implementação.',
  },
  {
    number: 3,
    title: 'Constituição da Holding',
    description: 'Cuidamos de toda a burocracia: abertura da empresa, elaboração do contrato social, transferência dos imóveis e registro em cartório.',
  },
  {
    number: 4,
    title: 'Gestão Contábil Contínua',
    description: 'Oferecemos acompanhamento contábil especializado para sua holding, garantindo conformidade fiscal e otimização tributária permanente.',
  },
];

export function HowItWorks() {
  return (
    <section id="como-funciona" className="py-20 lg:py-28 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Left Column: Header */}
          <div className="lg:sticky lg:top-32">
            <span className="text-gold-600 font-semibold text-sm uppercase tracking-wider">Como Funciona</span>
            <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 mt-3 mb-4">
              Etapas claras para você entender todo o processo
            </h2>
            <p className="text-lg text-neutral-600 mb-8">
              Da identificação de oportunidades fiscais à governança contínua da holding, garantimos transparência e compliance em cada passo.
            </p>

            {/* CTA */}
            <a
              href="#contato"
              onClick={() => trackContactClick('whatsapp', 'how_it_works')}
              className="inline-flex items-center justify-center rounded-lg bg-gold-500 px-6 py-3 text-base font-semibold text-white hover:bg-gold-600 transition-colors"
            >
              Começar Agora
            </a>
          </div>

          {/* Right Column: Steps */}
          <div className="steps-container">
            {steps.map((step, index) => (
              <StepCard
                key={step.number}
                number={step.number}
                title={step.title}
                description={step.description}
                isLast={index === steps.length - 1}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
